//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack, CloseFormEnum } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { ActivityListType, ActivityListFilter, ActivityListRequestModel, ActivityCreateModel } from '../Shared/Activity/Activity';
import { LegalFilter, LegalOrder } from './LegalModels';
import { Photos } from '../Shared/Photos/Photos';
import { CustomFilter, CustomFilterField, CustomFilterOperator, CustomFilterType } from '../Shared/Models/CustomFilterModels';
import { LegalEvents_AffectedPaths } from './LegalEvents_AffectedPaths';
import { LegalEvents_Consultations } from './LegalEvents_Consultations';
import { LegalEvents_Applicants } from './LegalEvents_Applicants';
import { UserDefinedFields } from '../Shared/UserDefinedFields/UserDefinedFields';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { CustomFiltersHelper } from '../Shared/Utility/CustomFiltersHelper';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { LegalEvents_LegalFeatures } from './LegalEvents_LegalFeatures';
import { LegalEvents_AffectedProperties } from './LegalEvents_AffectedProperties';
import { Feature } from 'ol';
import { legalEvents_Location } from './LegalEvents_Location';
import { ReportModel, SystemType } from '../Reports/ReportsModels';


// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',

    legalPanel = '#legalPanel',
    legalTypesListContainer = '#legalTypesListContainer',
    legalTypesListUserFilter ='#legalTypesListUserFilter',
    legalEventsRecordListContainer = '#legalEventsRecordListContainer',
    legalTypesListCloseBtn = '#legalTypesListCloseBtn',
    legalEventsRecordListCloseBtn = '#legalEventsRecordListCloseBtn',
    legalEventsRecordFilter = '#legalEventsRecordFilter',
    legalEventsRecordListPageAmount = '#legalEventsRecordListPageAmount',
    legalTypesViewRadioGroup = '#legalTypesViewRadioGroup',
    legalEventsRecordListShowingStartBtn = '#legalEventsRecordListShowingStartBtn',
    legalEventsRecordListShowingEndBtn = '#legalEventsRecordListShowingEndBtn',
    legalEventsRecordListShowingNextBtn = '#legalEventsRecordListShowingNextBtn',
    legalEventsRecordListShowingPrevBtn = '#legalEventsRecordListShowingPrevBtn',
    legalEventsRecordTable = '#legalEventsRecordTable',
    legalEventsCreateModal = '#legalEventsCreateModal',
    legalEventsCreateSubmitBtn = '#legalEventsCreateSubmitBtn',
    legalEventsCreateForm = '#legalEventsCreateForm',
    legalEventsCreateCloseBtn = '#legalEventsCreateCloseBtn',
    legalEventsCreateCancelBtn = '#legalEventsCreateCancelBtn',
    legalEventsEditModal = '#legalEventsEditModal',
    legalEventsEditOrderTable = '#legalEventsEditOrderTable',
    LegalEventsEdit_OrderPartial_AppealContainer = '#LegalEventsEdit_OrderPartial_AppealContainer',
    legalEventsEditSubmitBtn = '#legalEventsEditSubmitBtn',
    legalEventsEditForm = '#legalEventsEditForm',
    legalEventsEditCloseBtn = '#legalEventsEditCloseBtn',
    legalEventsEditCancelBtn = '#legalEventsEditCancelBtn',
    legalEventsSelectedView_Title = '#legalEventsSelectedView_Title',
    legalEventsSelectedView_TitleCount = '#legalEventsSelectedView_TitleCount',
    legalEventsRecordCount = '#legalEventsRecordCount',
    recordCountIndividual = '#recordCountIndividual',
    legalEventsRecordListShowing = '#legalEventsRecordListShowing',
    legalEventsQueryModal = '#legalEventsQueryModal',
    legalEventsQueryCancelBtn = '#legalEventsQueryCancelBtn',
    legalEventsQuerySubmitBtn = '#legalEventsQuerySubmitBtn',
    legalEventsQueryForm = '#legalEventsQueryForm',
    legalEventsRecordListPrintBtn = '#legalEventsRecordListPrintBtn',
    legalEventsRecordListNewEventBtn = '#legalEventsRecordListNewEventBtn',
    legalEventsRecordListEditEventBtn = '#legalEventsRecordListEditEventBtn',
    legalEventsRecordListDeleteEventBtn = '#legalEventsRecordListDeleteEventBtn',
    legalEventsRecordListCreatePlanBtn = '#legalEventsRecordListCreatePlanBtn',
    legalEventsRecordListQueryEventBtn = '#legalEventsRecordListQueryEventBtn',
    legalEventsQueryView_contactSearch = '#legalEventsQueryView_contactSearch',
    legalEventsQueryView_ContactTypeLUTList = '#legalEventsQueryView_ContactTypeLUTList',
    legalEventsActivityBtn = '#legalEventsActivityBtn',
    legalShowCustomFilterBtn = '#legalShowCustomFilterBtn',
    legalCustomFilterContainer = '#legalCustomFilterContainer',
    legalEventsEditNewActivityBtn = '#legalEventsEditNewActivityBtn',
    legalEventsEditActivityTable = '#legalEventsEditActivityTable'
}

export class LegalEvents {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private legalEventOrderEffectSelected: string;
    private currentPage: number = 0;
    private photos: Photos = new Photos();
    private currentSortOrder;
    private currentSortDirection: OrderDirection;
    private customFilterHelper = new CustomFiltersHelper();
    private customFilterDefinitions: Array<CustomFilter> = [];
    private customFilterEl: JQuery<HTMLElement>;

    private legalEvents_AffectedPaths: LegalEvents_AffectedPaths = new LegalEvents_AffectedPaths();
    private legalEvents_Consultations: LegalEvents_Consultations = new LegalEvents_Consultations();
    private legalEvents_Applicants: LegalEvents_Applicants = new LegalEvents_Applicants();
    private legalEvents_LegalFeatures: LegalEvents_LegalFeatures = new LegalEvents_LegalFeatures();
    private legalEvents_AffectedProperties: LegalEvents_AffectedProperties = new LegalEvents_AffectedProperties();
    private legalEvents_Location: legalEvents_Location = new legalEvents_Location();
    

    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: $(jqc.legalEventsRecordListPrintBtn+' button'), enable: false },
        new: { btn: $(jqc.legalEventsRecordListNewEventBtn +' button'), enable: false },
        edit: { btn: $(jqc.legalEventsRecordListEditEventBtn +' button'), enable: false },
        delete: { btn: $(jqc.legalEventsRecordListDeleteEventBtn +' button'), enable: false },
        create: { btn: $(jqc.legalEventsRecordListCreatePlanBtn + ' button'), enable: false },
        query: { btn: $(jqc.legalEventsRecordListQueryEventBtn + ' button'), enable: false },
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // When the module is furst loaded hide the main panels
        Utilities.GetControl(jqc.legalTypesListContainer).hide();
        Utilities.GetControl(jqc.legalEventsRecordListContainer).hide();

        // Events on the type list panel
        $(jqc.legalTypesViewRadioGroup+' input').on('change', function () { self.legalTypesViewChanged(); });

        // CLOSE BUTTONS
        Utilities.GetControl(jqc.legalTypesListCloseBtn).on('click', function () { Utilities.GetControl(jqc.legalPanel).removeClass('show'); });
        Utilities.GetControl(jqc.legalEventsRecordListCloseBtn).on('click', function () {
            Utilities.GetControl(jqc.legalPanel).removeClass('show');
            setTimeout(function () {
                Utilities.GetControl(jqc.legalEventsRecordListContainer).hide();
                self.OpenListPanel();
            }, 500);
        });

        // USER FILTER
        Utilities.GetControl(jqc.legalTypesListUserFilter).on('change', function () { self.GetLegalTypeCounts(); });

        // LEGAL EVENTS FILTER 
        Utilities.GetControl(jqc.legalEventsRecordFilter).on('change', function () { self.GetLegalEventData(); });
        Utilities.GetControl(jqc.legalEventsRecordListPageAmount).on('change', function () {
            var maxNo = $('#legalEventsRecordListPageAmount select').children("option:selected").val() as number;
            self.issueMaxNumberInList = maxNo != undefined ? maxNo : 10;
            self.GetLegalEventData();
        });

        // LEGAL EVENTS CUSTOM FILTER 
        // Get the custom filter definitions
        self.customFilterDefinitions = $(jqc.legalEventsRecordListContainer + ' [data-legalcustomfilterdefinitions]').data('legalcustomfilterdefinitions');

        self.customFilterHelper = new CustomFiltersHelper();
        Utilities.GetControl(jqc.legalShowCustomFilterBtn).on("click", function () {
            // Check if there are pcustom filters configured
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            Utilities.GetControl(jqc.legalCustomFilterContainer).addClass('show');
            Utilities.GetControl(jqc.legalShowCustomFilterBtn).addClass('text-success');
            self.customFilterHelper.customFilterAddRow(true);
            this.blur();
        });
        $(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterAddBtn"]').on("click", function () {
            self.customFilterHelper.customFilterAddRow();
            this.blur();
        });

        // Get the initial custom filter element for later on
        self.customFilterEl = $(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterRow"]').clone(false);
        $(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterRow"]').remove(); // Then remove it, it is added by the ADD button later on

        Utilities.GetControl(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterCloseBtn"]').on("click", function () {
            Utilities.GetControl(jqc.legalCustomFilterContainer).removeClass('show');
            Utilities.GetControl(jqc.legalShowCustomFilterBtn).removeClass('text-success');
            Utilities.GetControl(jqc.legalEventsRecordFilter).removeAttr("disabled");

            self.resetPage()
            Utilities.GetControl(jqc.legalEventsRecordFilter).prop("selectedIndex", 0);
            self.GetLegalEventData();
            this.blur();
        });
        Utilities.GetControl(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterSearchBtn"]').on("click", function () {
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            // Disable the pre-defined filters and set to 'Custom Filter'
            Utilities.GetControl(jqc.legalEventsRecordFilter).prop("selectedIndex", i);
            Utilities.GetControl(jqc.legalEventsRecordFilter).attr("disabled", "disabled");

            self.GetLegalEventData();
            this.blur();
        });

        // LEGAL EVENTS PAGING BTNS
        Utilities.GetControl(jqc.legalEventsRecordListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetLegalEventData();
        });
        Utilities.GetControl(jqc.legalEventsRecordListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetLegalEventData();
        });
        Utilities.GetControl(jqc.legalEventsRecordListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetLegalEventData();
        });
        Utilities.GetControl(jqc.legalEventsRecordListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetLegalEventData();
        });

        // LEGAL EVENTS ACTION BUTTONS
        self.actionBtns.viewprint.btn.on('click', function () {
            // Setup variables
            let data: ReportModel = {};
            var values: Array<string> = [];
            let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.legalEventsRecordFilter).children("option:selected").data('filterdefinition');
     
            // Get seleced nodes
            var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
            let rows: Array<any> = table.bootstrapTable('getSelections');
            if (rows != null) rows.forEach(r => values.push(r.LegalCode));

            // Get fdeature type
            if (values.length == 1) { data.systemType = SystemType.LegalEvents_Single; }
            else { data.systemType = SystemType.LegalEvents_Multi; }

            // Add custom filters
            var cf: Array<string> = [];
            var customFilters: Array<CustomFilter> = self.customFilterHelper.customFilterGetFilters();
            customFilters.forEach(c => {
                var str = JSON.stringify(c,
                    function replacer(key, value) {
                        // This will make sure the operator is returned as a number
                        // Important when the json is deserialized by the API
                        if (key === 'operator') {
                            return parseInt(value);
                        }
                        return value;
                    }
                );
                cf.push(str);
            });

            // If there is NO filterDef.viewName, then do not prompt the user 
            if (filterDef == null || filterDef.viewName == null) {
                var selectedMsg = "Selected Records Only (" + values.length + ")";
                data.reportParameters = [{ name: "codes", values: values }];
                events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
            }
            else if (values.length == 0) {
                var filterMsg = "Filter (" + filterDef.label + ")";
                data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                if (cf.length > 0) data.reportParameters.push({ name: "customFilters", values: cf });
                events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
            }
            else {
                var filterMsg = "Filter (" + filterDef.label + ")";
                var selectedMsg = "Selected Records Only (" + values.length + ")";

                var dataStr = [{ key: "AllLabel", value: filterDef.label }, { key: "FilterLabel", value: values.length }, { key: "YesBtn", value: values.length }, { key: "NoBtn", value: filterDef.label }];
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.RecordListReport, data: dataStr }).then(r => {
                    if (r.yes == true) {
                        data.reportParameters = [{ name: "codes", values: values }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
                    }
                    else {
                        data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                        if (cf.length > 0) data.reportParameters.push({ name: "customFilters", values: cf });
                        events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
                    }
                }).catch(e => { });

            }

        });
        self.actionBtns.new.btn.on("click", function () {
            self.openCreatePanel();
        });
        self.actionBtns.edit.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].LegalCode, featureType: FeatureType.LegalEvent };
            self.openEditPanel(data);
        });
        self.actionBtns.delete.btn.on("click", function () {
            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                if (r.yes == true) {
                    doDelete();
                }
                else {
                }
            }).catch(e => { });

            function doDelete() {
                var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.DeleteLegalEvent(rows[0].LegalCode);
            }
        });
        self.actionBtns.create.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].LegalCode, featureType: FeatureType.LegalEvent };
            events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
        });
        self.actionBtns.query.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].LegalCode, featureType: FeatureType.LegalEvent };
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
        });

        // LEGAL EVENTS TABLE
        // Initialize table
        var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
        if (table != null && table.bootstrapTable) {
            table.bootstrapTable();

            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
            });
            table.on('click-row.bs.table', function (e, row, $element, field) {
            });
            table.on('sort.bs.table', function (e, name, order) {
                e.preventDefault();
                switch (name) {
                    case "LegalCode":
                        self.currentSortOrder = LegalOrder.LegalCode;
                        break;
                    case "OrderTypeDescr":
                        self.currentSortOrder = LegalOrder.TypeDescr;
                        break;
                    case "CaseName":
                        self.currentSortOrder = LegalOrder.CaseName;
                        break;
                    case "AppReceivedDate":
                        self.currentSortOrder = LegalOrder.AppReceivedDate;
                        break;
                    case "PriorityDescr":
                        self.currentSortOrder = LegalOrder.Priority;
                        break;
                    case "TargetDate":
                        self.currentSortOrder = LegalOrder.TargetDate;
                        break;
                    case "StatusDescr":
                        self.currentSortOrder = LegalOrder.Status;
                        break;
                    default:
                        self.currentSortOrder = null;
                        break;
                }

                switch (order) {
                    case "asc":
                        self.currentSortDirection = OrderDirection.ASC;
                        break;
                    case "desc":
                        self.currentSortDirection = OrderDirection.DESC;
                        break;
                }

                self.GetLegalEventData();
            });
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "AnnotationCount") {
                    //if (row.AnnotationCount > 0) {
                    //    let data: ICAMSKey = { code: row.LegalCode, featureType: FeatureType.LegalEvent };
                    //    events.bus.publish(events.eventShowAnnotationsForFeature([data, false]));
                    //}
                    events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.LegalEvent]));
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenListPanel = (): void => {
        const self = this;

        // rest page
        $(jqc.legalTypesViewRadioGroup + " input[type='radio']:checked").prop("checked", false);
        Utilities.GetControl(jqc.legalEventsRecordListContainer).hide();
        self.resetPage();

        // Show the page
        Utilities.GetControl(jqc.legalTypesListContainer).show();
        Utilities.GetControl(jqc.legalPanel).css('width', '200px');
        Utilities.GetControl(jqc.legalPanel).addClass('show');

        self.GetLegalTypeCounts();
    }

    public OpenEventsPanel = (): void => {
        const self = this;

        // Show the page
        Utilities.GetControl(jqc.legalEventsRecordListContainer).show();
        Utilities.GetControl(jqc.legalPanel).css('width', '800px');
        Utilities.GetControl(jqc.legalPanel).addClass('show');
    }

    public openCreatePanel = (): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load('/Legal/LegalEventsCreate', function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsCreateModal, ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader(jqc.legalEventsCreateModal);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsCreateModal));

            Utilities.GetControl(jqc.legalEventsCreateSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsCreateForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(jqc.legalEventsCreateModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsCreateForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Legal/CreateLegalEvent',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                self.GetLegalEventData();
                                Utilities.GetModal(jqc.legalEventsCreateModal, ModalAction.Hide);

                                var data: ICAMSKey = { code: result.data.legalCode, featureType: FeatureType.LegalEvent };
                                self.openEditPanel(data);
                            }
                            else {
                                if (result.message == null) toastr.error('Failed to create event!');
                                else toastr.error(result.message)
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($(jqc.legalEventsCreateModal + " .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.legalEventsCreateCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsCreateModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.legalEventsCreateCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsCreateModal, ModalAction.Hide);
            });
        });
    }

    public openEditPanelViaLegalFeature = (legalFeatureID: string): void => {
        var self = this;

        self.legalEvents_LegalFeatures.GetLegalCodeFromLegalFeatureID(legalFeatureID).then(r => {
            var data: ICAMSKey = { code: r, featureType: FeatureType.LegalEvent };
            self.openEditPanel(data);
        })
    }
    
    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load('/Legal/LegalEventsEdit', { legalCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            
            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Create);

            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.legalEventsEditForm).serialize();

            Utilities.GetControl(jqc.legalEventsActivityBtn).on("click", function () {
                self.showActivityInPopover($(this), data, ActivityListType.LegalEventActivity, Utilities.GetControl(jqc.legalEventsEditModal));
                this.blur();
            });

            //initialise photo uploader
            self.photos.setupUploader(jqc.legalEventsEditModal);

            // Initialize different sections
            self.legalEvents_AffectedPaths.initEvents(data);
            //self.legalEvents_Consultations.initEvents(data);
            self.legalEvents_Applicants.initEvents(data);
            self.legalEvents_LegalFeatures.initEvents(data);
            self.legalEvents_AffectedProperties.initEvents(data);
            
            // LEGAL EVENTS ORDER TAB, VERSION TABLE
            var tableOrder: any = Utilities.GetControl(jqc.legalEventsEditOrderTable)
            tableOrder.bootstrapTable();

            // Location
            self.legalEvents_Location.initMainPanel(data);
            
            // Disable/enable appeal panel
            $(jqc.legalEventsEditModal + ' [name="OCAppealLodged"]').on('change', function () {
                if ($(this).is(":checked") == true) {
                    Utilities.GetControl(jqc.LegalEventsEdit_OrderPartial_AppealContainer).css('pointer-events', 'auto');
                    $(jqc.LegalEventsEdit_OrderPartial_AppealContainer + ' h6').css('color', 'midnightblue');
                }
                else {
                    Utilities.GetControl(jqc.LegalEventsEdit_OrderPartial_AppealContainer).css('pointer-events', 'none');
                    $(jqc.LegalEventsEdit_OrderPartial_AppealContainer + ' h6').css('color', 'grey');
                }
            });
            $(jqc.legalEventsEditModal + ' [name="OCAppealLodged"]').change();

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsEditModal));

            Utilities.GetControl(jqc.legalEventsEditSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                if ($(jqc.legalEventsEditForm + ' [name="AddToRegister"]').is(":checked") == false) {
                    doSubmit();
                    //ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.LegalPublishToRegister }).then(r => {
                    //    if (r.yes == true) {
                    //        doSubmit();
                    //    }
                    //    else {
                    //    }
                    //}).catch(e => { });
                } else {
                    doSubmit();
                }
            });
          
            Utilities.GetControl(jqc.legalEventsEditCloseBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.legalEventsEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                    });
                }
                else Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.legalEventsEditCancelBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.legalEventsEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                    });
                }
                else Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
            });
          
            Utilities.GetControl(jqc.legalEventsEditNewActivityBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.legalEventsEditForm).serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => { if (s == true) openForm(); });
                    });
                }
                else openForm();

                function openForm() {
                   Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                    var activityData: ActivityCreateModel = { ID: data.code, activityListType: ActivityListType.LegalEventActivity };
                    events.bus.publish(events.eventOpenActivityCreatePanel([activityData, function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenLegalEventsEditPanel(data)); // This re-opens the edit form which refreshes the Route form
                        }
                        else {
                            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                        }
                    }]));
                }
            });
            // ACTIVITY
            getActivities(true); // Get activities when the form first loads
            Utilities.GetControl(jqc.legalEventsEditForm  + ' [name="showAllActivities"]').on('change', function () {
                var checked = $(this).prop('checked');
                getActivities(!checked);
            });
            function getActivities(excludeAuditActivities: Boolean) {
                events.bus.publish(events.eventGetActivities([data, excludeAuditActivities, function (d) {
                    var table = (Utilities.GetControl(jqc.legalEventsEditActivityTable) as any);
                    table.bootstrapTable();
                    table.bootstrapTable('load', d);

                    // Add entity cklick events
                    Utilities.GetControl(jqc.legalEventsEditForm + ' [data-activityid]').on('click', function () {
                        const ID: number = $(this).data("activityid");
                        if (originalFormData !== Utilities.GetControl(jqc.legalEventsEditForm).serialize()) {
                            Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                                if (r == CloseFormEnum.DisregardAndProceed) openContact();
                                else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                    if (s == true) openContact();
                                });
                            });
                        }
                        else openContact();

                        function openContact() {
                            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                            events.bus.publish(events.eventOpenActivityDetailsPanel([ID, function (r) {
                                if (r == true) {
                                    events.bus.publish(events.eventOpenLegalEventsEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                                }
                                else {
                                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                }
                            }]));
                        }
                    });
                }]));
            }

            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {
                    Utilities.BlockUI($(jqc.legalEventsEditModal + " .modal-content"));
                    let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEditForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Legal/UpdateLegalEvent',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    UserDefinedFields.SaveUDFFieldsAtServer(Utilities.GetControl(jqc.legalEventsEditForm), '/Legal/UpdateLegalUserFields');
                                    // also update the legalRoutes if they were edited
                                    //self.legalEvents_AffectedPaths.UpdateLegalRouteData(null);
                                    self.legalEvents_LegalFeatures.UpdateLegalFeatureInLineData();
                                    self.legalEvents_Applicants.UpdateLegalApplicantData();

                                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                                    resolve(true);
                                }
                                else {
                                    if (result.message == null) toastr.error('Failed to edit event!');
                                    else toastr.error(result.message);
                                    resolve(false);
                                }
                            }
                            catch (err) {
                                console.log(err);
                                resolve(false);
                            }
                            finally {
                                Utilities.UnBlockUI($(jqc.legalEventsEditModal + " .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                        resolve(false);
                    });
                });
            }



            // TEST CODE          
            
           
        });
       
    }

    // GET DATA FROM SERVER
    private GetLegalEventData = (): void => {
        const self = this;

        // Get the filter and URL
        //let filterVal = Utilities.GetControl(jqc.legalEventsRecordFilter).children("option:selected").val() as LegalFilter;
        var customFilters: Array<CustomFilter> = self.customFilterHelper.customFilterGetFilters();
        let contactRef = Utilities.GetControl(jqc.legalTypesListUserFilter).val();

        // Also add a custom filter for the legaltype already selected by the user
        var field: CustomFilterField = { fieldName: "LegalOrderTypeLUT.Effect", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals] };
        customFilters.push({ field: field, operator: CustomFilterOperator.Equals, searchValue: self.legalEventOrderEffectSelected });

        let viewName = "";
        let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.legalEventsRecordFilter).children("option:selected").data('filterdefinition');
        if (filterDef != null) { viewName = filterDef.viewName; }

        let url = "/Legal/GetLegalEvents";
        let query = { data: { ViewName: viewName, CustomFilters: customFilters, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList, ContactRef: contactRef } };

        Utilities.BlockUI(Utilities.GetControl(jqc.legalEventsRecordListContainer));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)

                        table.bootstrapTable('load', data)
                        self.updatePagingUI();

                        // Update count
                        var countStr = " (" + result.totalCount + ")";
                        self.issueCountFromServer = result.totalCount;
                        Utilities.GetControl(jqc.legalEventsSelectedView_TitleCount).html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsRecordListContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetLegalTypeCounts = (): void => {
        const self = this;
        let url = "/Legal/GetLegalTypesCount";
        let contactRef = Utilities.GetControl(jqc.legalTypesListUserFilter).val();
        let query = { filters: [LegalFilter.All], contactRef: contactRef} ;
        
        Utilities.BlockUI(Utilities.GetControl(jqc.legalTypesListContainer));
        $.post(url, query, function (response: IAPIResult) {
            try {
                Utilities.UnBlockUI(Utilities.GetControl(jqc.legalTypesListContainer));
                if (response.success == true) {
                    $('[name="legalTypesRadioGroup"]').css('display', 'none'); // Hide all of the radio fields
                    response.data.forEach(f => {
                        // Only show the ones with values
                        var keyStr = (f.key as string).replace(' ', '').replace('(', '').replace(')', '');
                        let el = $('#legalTypesRadio_' + keyStr);
                        if (el != null && el.parent() != null) {
                            $('#legalTypesRadio_' + keyStr).parent().css('display', 'block');
                        }

                        // Update the count number and set the styles
                        let elCount = $('#legalTypesRadio_' + keyStr + 'Count');
                        if (elCount != null && elCount.parent() != null) {
                            elCount.html(f.value);
                            setViewStyle(elCount.parent(), Number.parseInt(f.value));
                        }
                    });
                }
            }
            catch (err) {
                console.log(err);
                alert(err);
            }
            finally {
                Utilities.UnBlockUI(Utilities.GetControl(jqc.legalTypesListContainer));
            }
        });

        function setViewStyle(el, num: number) {
            if (num > 0) {
                el.css('font-weight', '600');
                el.css('color', 'black');
            }
            else {
                el.css('font-weight', '400');
                el.css('color', '#6c757d');
            }
        }
    }

    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsRecordTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
            self.actionBtns.create.enable = true;
            self.actionBtns.query.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.actionBtns.viewprint.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private DeleteLegalEvent = (legalCode: string): void => {
        const self = this;

        let url = "/Legal/DeleteLegalEvent";
        let query = { legalCode: legalCode };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.GetLegalEventData();
                    }
                    else {
                        toastr.error("Failed to delete item.")
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private legalTypesViewChanged = (): void => {
        const self = this;
        this.resetPage();

        let filterStr: string = "";
        let selected = $(jqc.legalTypesViewRadioGroup+" input[type='radio']:checked");
        if (selected.length > 0) {
            self.legalEventOrderEffectSelected = selected.data('ordertypeeffect');
            filterStr = selected.parent().text();
            filterStr = filterStr.substring(0, filterStr.indexOf('('));
        }
        Utilities.GetControl(jqc.legalEventsSelectedView_Title).html(filterStr);
        
        // Show forms
        Utilities.GetControl(jqc.legalPanel).removeClass('show');
        setTimeout(function () {
            Utilities.GetControl(jqc.legalTypesListContainer).hide();
            self.OpenEventsPanel();
        }, 500);

        // Reset custom filters
        self.customFilterHelper.init(Utilities.GetControl(jqc.legalCustomFilterContainer), self.customFilterEl, self.customFilterDefinitions);
        Utilities.GetControl(jqc.legalCustomFilterContainer).removeClass('show');
        Utilities.GetControl(jqc.legalShowCustomFilterBtn).removeClass('text-success');

        // Update the second filter
        this.checkFilters();

        // Get the data
        self.GetLegalEventData();
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { Utilities.GetControl(jqc.legalEventsRecordCount).html(' (' + self.issueCountFromServer + ')'); } else { Utilities.GetControl(jqc.recordCountIndividual).html(); }
        Utilities.GetControl(jqc.legalEventsRecordListShowing).html((self.currentPage + 1).toString());

        self.checkVisibleButtons();
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;

        $(jqc.legalTypesViewRadioGroup + ' label').removeClass('active');
        $(jqc.legalCustomFilterContainer + ' [name="recordListCustomFilterRow"]').remove();

        var maxNo = $(jqc.legalEventsRecordListPageAmount + 'select').children("option:selected").val() as number;
        this.issueMaxNumberInList = maxNo != undefined ? maxNo : 10;
        this.updatePagingUI();
    }

    private checkFilters = (forceTasks: boolean = false): void => {
        Utilities.GetControl(jqc.legalEventsRecordFilter).find('option').remove().end();
        let filters: Array<IFilterDefinitionModel> = $(jqc.legalEventsRecordListContainer + ' [data-legalfilters]').data('legalfilters');
        filters.forEach(f => {
            Utilities.GetControl(jqc.legalEventsRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
        });
    }

    private showActivityInPopover = (el: JQuery<HTMLElement>, data: ICAMSKey, activityType: ActivityListType, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.code, ActivityListType: activityType, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([el, model, parentModal]));
    }

    private getPredefinedFilterIndexOfCustomFilter = (): number => {
        var i = -1; var counter = 0;

        Utilities.GetControl(jqc.legalEventsRecordFilter + " option").each(function () {
            var data: IFilterDefinitionModel = $(this).data('filterdefinition');
            if (data && data.customFilter && data.customFilter == true) {
                i = counter;
            }
            counter++;
        });
        return i;
    }
}




